import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllGenesisSaleUserSuccess,
  getAllGenesisSaleUserFailed,
  GET_ALL_GENESIS_SALE_USER_START,
} from '../../actions/genesis'

/**
 * get list genesis sale user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListGenesisSaleUserApi = (props) => {
  var uri = `/users/genesis/sales`
  return api.get(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListGenesisSaleUser(action) {
  try {
    const response = yield call(getListGenesisSaleUserApi, action?.payload)
    yield put(getAllGenesisSaleUserSuccess(response?.data))

    // Call callback action if provided
    if (action.onSuccess) {

      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllGenesisSaleUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list genesis user
 */
export default function* watchGetListGenesisSaleUser() {
  yield takeLatest(GET_ALL_GENESIS_SALE_USER_START, doGetListGenesisSaleUser)
}
